import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import { alllanguage } from "../../data/lang/index";
import { Ilanguage } from "../../core/interface/Icommon";
import withWinCelebrationConfiguration from "./configuration/withWinCelebrationConfiguration";
import { isMobile } from "react-device-detect";
import { configGame, constant } from "../../data/config";
import { CURRENCY } from "../../core/utills";
import { actions as winCelebrationActions } from "../../gamereducer/winCelebrationReducer";
import { BaseAnimatedparticle } from "../../core/components/effect/baseanimatedparticle";
import { TIMER } from "../../core/utills";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { Tween } from "../../core/components/effect/tween";
import { actions as basegameAction } from "../../core/reducers/baseGameReducer";
import { actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { actions as keyboardListenerActions } from "../../core/reducers/keyboardListenerReducer";
import { actions as flowManagerAction } from "../../core/reducers/flowManagerReducer";
import { actions as retriggerActions } from "../../gamereducer/retriggerReducer";
import { actions as gameRandomWildActions } from '../../gamereducer/gameRandomWildReducer';
import { Baseparticle } from "../../core/components/effect/baseparticle";
import easing from "../../core/components/effect/easing";

interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IStateToProps {
    [x: string]: any;
}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class WinCelebration extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected winCelebrationContainer: _ReactPixi.IContainer | Ref<any>;
    private alllanguage: Ilanguage;
    private tickupRequest: any;
    protected tweening: any;
    protected ui_mode: string;
    protected displayUI: any;
    protected thresholdSuperWin: any
    protected thresholdMegaWin: any
    protected thresholdLegendaryWin: any
    protected Baseparticle: any
    protected wincelebrationText: any
    protected wincelebrationTextPortrait: any
    private lowerTargetValue: number = 0.5;
    private higherTargetValue: number = 1.5;
    protected currentCelebrationState: any
    private winCelebrationLabelDL: any;
    private winCelebrationLabelPortrait: any
    private winCelebrationLableDLName: any
    private winCelebrationLablePortraitName: any
    private winCelebration_Graphic: any;
    private T1000: number = 1000;
    private T2000: number = 2000;
    private T1500: number = 1500;
    private tickupScale: number = 0.002;
    private tickUpValue: number = 0;
    private finalTickUpValue: number = 25;
    private T200: number = 200;
    private maximumScalingOfTickUp: number = 0.6;
    private tickupTimeMaxMegaWin: number = 11000;
    private tickupTimeLegendaryWin: number = 89000;
    private tickupTimeMidMegaWin: number = 30000;
    private winRange: number = 500;
    private winRange2: number = 250;
    private T300: number = 300;
    private T100: number = 100;
    private toConvertInSec: number = 1000;
    private previousSound: string = "bgloop";
    private baseGameSound: string = "bgloop";
    private startWinSound: boolean = false;
    private isClicked: boolean = false;
    private isClosedScreen: boolean = false;
    private tickUpScalingTimer: number = 50;
    private tickUpScalingDelay: number = 20;
    private handleEventTimer: number = 1000;
    private tickUpStartingScaling: number = 0.70;
    private tickUpActualScaling: number = 1;
    private coinContainerX: number = -400;
    private coinContainerY: number = 300;
    private tweenTimer: number = 0.001;
    private decreasingAlpha: number = 0.18;
    private decreasingAlphaTimer: number = 100;
    private storeBetValue: number = 0;
    private bigWinValue: number = 25;
    private finalTextOnClick: any;
    protected constantT1: number = 100;
    private constantValue: number = 1;
    private addExtraTime: number = 2000;
    private addExtraTimeT2: number = 5000;
    private addExtraTimeT3: number = 45000;
    private bigWinTimer: number = 3000;
    private superWinTimer: number = 7000;
    private megaWinTime: number = 12000;
    private legendaryWinTime: number = 25000;
    private buttonEnabled: boolean = false;
    private clickCounter: number = 0;


    constructor(props: IProps) {
        super(props);
        this.app = props.app;

        this.alllanguage = alllanguage;
        this.state = {
            uiElements: [],
            lang: "en",
            width: this.props.width,
            height: this.props.height,
            pixelRatio: window.devicePixelRatio,
            resizing: false,
        }
        this.winCelebrationContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";

        }
        this.tweening = [];

        this.thresholdSuperWin = 100;
        this.thresholdMegaWin = 200;
        this.thresholdLegendaryWin = 500;
        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));
    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    layoutChange(currentLayout: string) {
        this.setPortraitPosition();
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }
    coinShower() {
        let coinConfig = {

            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.3,
                "end": 0.6
            },
            "speed": {
                "start": 2000,
                "end": 2000
            },
            "acceleration": {
                "x": 10,
                "y": 1830
            },
            "startRotation": {
                "min": 250,
                "max": 290
            },
            "rotationSpeed": {
                "min": 100,
                "max": 150
            },
            "lifetime": {
                "min": 2,
                "max": 2
            },
            "blendMode": "normal",
            "frequency": 0.1,
            "emitterLifetime": -1,
            "maxParticles": 30,
            "pos": {
                "x": 900,
                "y": 1200
            },
            "addAtBack": false,
            "spawnType": "circle",
            "spawnCircle": {
                "x": 0,
                "y": 0,
                "r": 100
            }
        }

        let animmationconfig = {
            //framerate is required. It is the animation speed of the particle in frames per
            //second.
            //A value of "matchLife" causes the animation to match the lifetime of an individual
            //particle, instead of at a constant framerate. This causes the animation to play
            //through one time, completing when the particle expires.
            framerate: 30,
            //loop is optional, and defaults to false.
            loop: true,
            //textures is required, and can be an array of any (non-zero) length.
            textures: UIManager.getRef("coins_Anim").textures
        }
        this.Baseparticle = new BaseAnimatedparticle(UIManager.getRef("winCelebration_Container_" + this.ui_mode), animmationconfig, coinConfig)
    }

    componentDidMount() {
        if (this.props.showWinCelebration) {
            this.layoutChange(this.props.layoutMode);
        }
        /* setTimeout(() => {
            this.props.winCelebrationShow(true);

            this.props.winCelebrationStart(true, "Cash");
        }, 2000); */

    }

    addTweenEffectsOnTickup() {

        const textTickup = UIManager.getRef("Text_amount_tickup_" + this.ui_mode);
        const droppingTweenX = new Tween(
            [textTickup.scale],
            {

                'x': { start: 1, end: 1.1 },
                'y': { start: 1, end: 1.1 }
            },
            0.5,
            easing.easeLinear,
            false, null, null, null, null, false, onchange, () => {

                const droppingTweenX = new Tween(
                    [textTickup.scale],
                    {

                        'x': { start: 1.1, end: 1 },
                        'y': { start: 1.1, end: 1 }
                    },
                    0.5,
                    easing.easeLinear,
                    false, null, null, null, null, false, onchange, () => {
                        this.addTweenEffectsOnTickup();
                    }
                );
            }
        );
    }

    particleShower() {
        let coinConfig = {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 1,
                "end": 0.1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 300,
                "end": 300,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": 0
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 90,
                "max": 90
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 10,
                "max": 10
            },
            "blendMode": "normal",

            "frequency": 0.3,
            "emitterLifetime": -1,
            "maxParticles": 500,
            "pos": {
                "x": 0,
                "y": -50
            },
            "addAtBack": true,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": 1920,
                "h": 50
            }
        }

        this.Baseparticle = new Baseparticle(UIManager.getRef("winCelebration_Container_" + this.ui_mode), UIManager.getRef("leaf_Anim").texture, coinConfig, null)
    }

    setPortraitPosition() {
        let coinCointainer: any = UIManager.getRef("winCelebration_Container_" + this.ui_mode);
        if (isMobile && window.innerWidth < window.innerHeight) {
            coinCointainer && (coinCointainer.x = this.coinContainerX);
            coinCointainer && (coinCointainer.y = this.coinContainerY);
        } else {
            coinCointainer && (coinCointainer.x = 0);
            coinCointainer && (coinCointainer.y = 0);
        }
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.soundIsPlaying !== this.props.soundIsPlaying) {
            if (nextProps.soundIsPlaying !== this.props.soundIsPlaying) {
                return false;
            }
            if (UIManager.getRef("Text_amount_tickup_" + this.ui_mode) !== undefined) {
                this.interactivityTrue(true);
                UIManager.getRef("Text_amount_tickup_" + this.ui_mode).visible = true;
                this.buttonEnabled = false;

                this.clickCounter = 0;
                this.isClosedScreen = false;
                UIManager.getRef("Text_amount_tickup_" + this.ui_mode).objectInstance.startTickup(nextProps.totalCreditWinAmount);
                this.coinShower();
                // this.particleShower();
            }
            return false;
        }


        if (nextProps.layoutMode !== this.props.layoutMode && nextProps.showWinCelebration) {
            this.layoutChange(nextProps.layoutMode)
            this.onOrientationChange();
            //this.wincelebrationText.scale.set(this.higherTargetValue);
            return false;
        }
        if (nextProps.showWinCelebration && nextProps.showWinCelebration !== this.props.showWinCelebration) {
            return true;
        }
        if (nextProps.startWinCelebration && nextProps.startWinCelebration !== this.props.startWinCelebration) {

            this.storeBetValue = this.props.betList[this.props.currentBetIndex];
            this.layoutChange(this.props.layoutMode);
            //this.textTweening()
            //this.tickupTextScaling();
            this.addTweenEffectsOnTickup();
            this.startWinSound = true;
            this.initialize();
            this.onOrientationChange();
            if (UIManager.getRef("Text_amount_tickup_" + this.ui_mode) !== undefined) {
                this.interactivityTrue(true);
                this.setTimeOfWin();
                UIManager.getRef("Text_amount_tickup_" + this.ui_mode).visible = true;
                this.buttonEnabled = false;
                this.clickCounter = 0;
                this.isClosedScreen = false;
                UIManager.getRef("Text_amount_tickup_" + this.ui_mode).objectInstance.startTickup(this.props.totalCreditWinAmount);
                this.coinShower();
                // this.particleShower();
            }
            return false;
        }
        return true;
    }

    setTimeOfWin() {

        if (this.props.totalCreditWinAmount < this.thresholdSuperWin * this.storeBetValue) {
            UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.bigWinTimer;
            if (this.storeBetValue < 1) {
                UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.bigWinTimer

            }
        }
        else if (this.props.totalCreditWinAmount >= this.thresholdSuperWin * this.storeBetValue && this.props.totalCreditWinAmount < this.thresholdMegaWin * this.storeBetValue) {
            UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.superWinTimer;
            if (this.storeBetValue < 1) {
                UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.bigWinTimer;

            }
        }
        else if (this.props.totalCreditWinAmount >= this.thresholdMegaWin * this.storeBetValue && this.props.totalCreditWinAmount < this.thresholdLegendaryWin * this.storeBetValue) {
            UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.megaWinTime;
            if (this.storeBetValue < 1) {
                UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.bigWinTimer;
            }
        }
        else if (this.props.totalCreditWinAmount >= this.thresholdLegendaryWin * this.storeBetValue) {
            UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.legendaryWinTime;
            if (this.storeBetValue < 1) {
                UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.bigWinTimer;
            }
        }
        UIManager.getRef("Text_amount_tickup_" + this.ui_mode).tickuptime = this.bigWinTimer;
    }

    interactivityTrue(value: boolean) {
        UIManager.getRef("winCelebrationContainer").buttonMode = true;
        UIManager.getRef("winCelebrationContainer").interactive = true;

        if (isMobile) {
             UIManager.getRef("winCelebrationContainer").addListener('touchend', (evt: MouseEvent): void => {
                 this.handleEvents();
             }) 
        } else {

            UIManager.getRef("winCelebrationContainer").click = (event: any) => {
                UIManager.getRef("winCelebrationContainer").buttonMode = false;
                UIManager.getRef("winCelebrationContainer").interactive = false;

                this.handleEvents();
            }
        }
    }

    onOrientationChange() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            // this.winCelebrationLabelPortrait.visible = true;
            this.winCelebration_Graphic && (this.winCelebration_Graphic.width = configGame.CANVAS_HEIGHT);
            this.winCelebration_Graphic && (this.winCelebration_Graphic.height = configGame.CANVAS_WIDTH);

        } else {

            // this.winCelebrationLabelPortrait && (this.winCelebrationLabelPortrait.visible = false);
            this.winCelebration_Graphic && (this.winCelebration_Graphic.width = configGame.CANVAS_WIDTH);
            this.winCelebration_Graphic && (this.winCelebration_Graphic.height = configGame.CANVAS_HEIGHT);
        }
    }

    initialize() {
        //   this.winCelebrationLablePortraitName = "text_WinCelebration_label_mobile_portrait"
        //this.winCelebrationLabelPortrait = UIManager.getRef(this.winCelebrationLablePortraitName);
        this.winCelebration_Graphic = UIManager.getRef("winCelebration_Graphic_new");
        //  this.winCelebrationLabelPortrait && (UIManager.setText(this.winCelebrationLablePortraitName, this.props.langObj["winCelebration_bigWin"]));
        // this.winCelebrationLabelPortrait && this.winCelebrationLabelPortrait.scale.set(this.lowerTargetValue);



    }

    addTweenEffects(obj: any, textUpdate: any) {

    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }

    onTickupUpdate(e?: any) {
        let totalWin = this.props.totalCreditWinAmount
        if (e.value > (totalWin)) {
            e.value = (totalWin);
        }
        this.storeBetValue = this.props.betList[this.props.currentBetIndex];
        if (e.name === "Text_amount_tickup_" + this.ui_mode) {
            if (this.tickUpValue === (totalWin)) {
                e.value = (totalWin);

                if (isMobile && window.innerWidth < window.innerHeight) {
                    // UIManager.getRef("text_WinCelebration_label_mobile_portrait").text = this.finalTextOnClick;

                }
            }
            if (this.props.showAmount === 'Cash') {
                e.updateTextFromOutside = true;
                e.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(e.value, true, true, true, true));
            }
            if (this.props.showAmount === 'Coin') {
                e.updateTextFromOutside = false;
            }
            if (e.value >= 0 && e.value < this.thresholdSuperWin * this.storeBetValue) {
                if (this.startWinSound) {
                    this.soundsOn("bigWinLoop", this.previousSound);
                    this.startWinSound = false;
                }
                this.currentCelebrationState = "BIGWIN";


            }
            if (e.value >= this.thresholdSuperWin * this.storeBetValue && e.value < this.thresholdMegaWin * this.storeBetValue && this.currentCelebrationState === "BIGWIN") {
                //  UIManager.getRef("Text_amount_tickup_desktop").tickuptime=82000;
                this.soundsOn("superWinLoop", this.previousSound);
                this.currentCelebrationState = "SUPERWIN";
            }

            if (e.value >= this.thresholdMegaWin * this.storeBetValue && e.value < this.thresholdLegendaryWin * this.storeBetValue && this.currentCelebrationState === "SUPERWIN") {
                this.soundsOn("megaWinLoop", this.previousSound);
                this.currentCelebrationState = "MEGAWIN";
            }

            if (e.value >= this.thresholdLegendaryWin * this.storeBetValue && this.currentCelebrationState === "MEGAWIN") {
                this.soundsOn("ultraWinLoop", this.previousSound);
                this.currentCelebrationState = "LEGENDARYWIN";
            }
            this.tickUpValue = e.value;
        }
        this.onOrientationChange();
    }

    onTickupComplete(e?: any) {

        if (e != null) {
            e.value = (this.props.totalCreditWinAmount).toFixed(2);
            let tickUpValue = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(e.value, true, true, true, true));
            UIManager.getRef("Text_amount_tickup_" + this.ui_mode) && (UIManager.setText("Text_amount_tickup_" + this.ui_mode, tickUpValue));

            if (e.value >= 0 && e.value < this.thresholdSuperWin * this.storeBetValue) {
                if (this.startWinSound) {
                    this.soundsOn("bigWinLoop", this.previousSound);
                    this.startWinSound = false;
                }
                //  this.winCelebrationLabelPortrait && (UIManager.setText(this.winCelebrationLablePortraitName, this.props.langObj["winCelebration_bigWin"]));
                // this.winCelebrationLabelPortrait && this.winCelebrationLabelPortrait.scale.set(this.higherTargetValue);
                this.currentCelebrationState = "BIGWIN";


            }
            if (e.value >= this.thresholdSuperWin * this.storeBetValue && e.value < this.thresholdMegaWin * this.storeBetValue && this.currentCelebrationState === "BIGWIN") {
                this.soundsOn("superWinLoop", this.previousSound);
                this.currentCelebrationState = "SUPERWIN";
            }

            if (e.value >= this.thresholdMegaWin * this.storeBetValue && e.value < this.thresholdLegendaryWin * this.storeBetValue && this.currentCelebrationState === "SUPERWIN") {
                this.soundsOn("megaWinLoop", this.previousSound);
                this.currentCelebrationState = "MEGAWIN";
            }

            if (e.value >= this.thresholdLegendaryWin * this.storeBetValue && this.currentCelebrationState === "MEGAWIN") {
                this.soundsOn("ultraWinLoop", this.previousSound);
                this.currentCelebrationState = "LEGENDARYWIN";
            }
        }
        if (!this.isClicked) {
            if (e != null) {
                e.value = 0;
                this.CloseScreen();
            }
        }
    }


    tweenTo(object: any, property: any, target: any, time: any, easing: any, onchange: any, oncomplete: any, start?: number) {

        new Tween(
            [object],
            {

                [property]: { start: object[property], end: target }
            },
            time || this.tweenTimer,
            easing,
            false, null, null, null, null, false, onchange, oncomplete
        );

    }


    soundsOn(current: any, previous: any) {
        if (this.props.soundIsPlaying) {
            this.props.stopSound([{ name: previous }]);
            this.props.playSound([{ name: current, loop: true }]);
            this.previousSound = current;

        }
    }

    setWincelebrationGraphic() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            this.winCelebration_Graphic && (this.winCelebration_Graphic.width = configGame.CANVAS_HEIGHT);
            this.winCelebration_Graphic && (this.winCelebration_Graphic.height = configGame.CANVAS_WIDTH);

        } else {
            this.winCelebration_Graphic && (this.winCelebration_Graphic.width = configGame.CANVAS_WIDTH);
            this.winCelebration_Graphic && (this.winCelebration_Graphic.height = configGame.CANVAS_HEIGHT);
        }
    }


    handleEvents() {


        if (this.clickCounter == 0) {
            this.isClicked = true;
            this.clickCounter++;
            this.props.stopSound([{ name: this.previousSound }]);
            UIManager.getRef("Text_amount_tickup_" + this.ui_mode).objectInstance.stopTickup();
            this.tickUpValue = this.props.totalCreditWinAmount;
            let timer = TIMER.TimerManager.createTimer(this.handleEventTimer);
            timer.on('end', () => {
                this.isClicked = false;

                this.CloseScreen();

                timer.remove();
            });
            timer.start(false, this.handleEventTimer);
        }
    }
    CloseScreen() {
        if (this.isClosedScreen) {
            //this.isClosedScreen = true;
            return;
        }
        this.isClosedScreen = true;


        let timer = TIMER.TimerManager.createTimer(this.decreasingAlphaTimer);
        timer.on('repeat', (i: number) => {
            this.props.changeVolume([{ name: this.baseGameSound, loop: true, vol: 0.4 }]);
            UIManager.getRef("winCelebrationContainer").alpha -= this.decreasingAlpha;
            if (UIManager.getRef("winCelebrationContainer").alpha < 0) {
                timer.stop();
                this.tickUpValue = 0;

                this.props.winCelebrationShow(false);
                //this.props.winCelebrationStart(false, "Cash");
                this.props.winCelebrationStart(false, this.props.displayInCoins ? "Coin" : "Cash");
                if (this.props.inFreeGame) {

                    if (this.props.featureType == "BONUS" || this.props.featureType == "FREEGAME") {

                        if (this.props.featureJustReTriggered) {

                            let nextSpinTimer = 2000;
                            if (this.props.retriggerCount > 0) {
                                let timerRetrigger = TIMER.TimerManager.createTimer(1000);
                                timerRetrigger.on('end', (e: any, data: any) => {
                                    this.props.showFeatureRetrigger();
                                })
                                timerRetrigger.start();

                                nextSpinTimer = 3000;
                            }
                            let timer = TIMER.TimerManager.createTimer(nextSpinTimer);
                            timer.on('end', (e: any, data: any) => {

                                this.props.nextAutoplay();
                                this.props.nextFreegame();
                            })
                            timer.start();

                        }
                        else {

                            //intro,nextspin
                            let timer = TIMER.TimerManager.createTimer(this.props.outroBannerSkipped ? 0 : 1500);
                            if (this.props.featureJustFinished) {
                                this.props.flowManagerCalled(true);

                            }
                            timer.on('end', (e: any, data: any) => {

                                if (this.props.featureJustFinished) {
                                    this.props.featureActive(false);
                                    let timer2 = TIMER.TimerManager.createTimer(this.props.outroBannerSkipped ? 0 : 2000);
                                    timer2.on('end', (e: any, data: any) => {
                                        if (!this.props.inFreeGame) {
                                            return
                                        }
                                        this.props.stopFreegame();
                                        //RAJANU set freegame initial reelgrid
                                        let reelData = [
                                            [31, 19, 19, 19, 19, 19, 19, 19, 19],
                                            [31, 31, 19, 31, 31, 31, 19, 19, 31],
                                            [1, 1, 1, 1, 1, 1, 1, 1, 1],
                                            [21, 21, 21, 21, 39, 21, 21, 21, 21],
                                            [52, 46, 10, 34, 28, 28, 46, 52, 52],
                                            [14, 56, 2, 44, 14, 14, 44, 44, 56],
                                            [2, 14, 8, 20]
                                        ]
                                        let FWReelData;
                                        FWReelData = {
                                            stopReels: reelData,
                                        }

                                        //  this.props.relGridSymbolCountDisplay([3, 3, 3, 5, 6, 4])

                                        // this.props.updateReelData(FWReelData);
                                        this.props.setApplicationToBaseGameState(true);


                                        let timer4 = TIMER.TimerManager.createTimer(this.constantT1);
                                        timer4.on('end', (e: any, data: any) => {

                                            this.props.setAllButtonEnable();
                                            this.props.nextAutoplay();
                                            this.props.nextFreegame();
                                        })
                                        timer4.start();


                                    })
                                    timer2.start();

                                } else {

                                    let nextSpinTimer = 0;
                                    if (this.props.retriggerCount > 0) {
                                        this.props.showFeatureRetrigger();
                                        nextSpinTimer = 3000;
                                    }
                                    let timer = TIMER.TimerManager.createTimer(nextSpinTimer);
                                    timer.on('end', (e: any, data: any) => {
                                        this.props.nextAutoplay();
                                        this.props.nextFreegame();
                                        this.props.setAllButtonEnable();

                                    })
                                    timer.start();

                                }
                            })
                            timer.start();

                        }
                    } else {
                        this.props.nextAutoplay();
                        this.props.nextFreegame();
                        //this.props.setAllButtonEnable();
                    }


                } else {
                    this.props.nextAutoplay();
                    this.props.nextFreegame();
                }
                //UIManager.getRef("text_WinCelebration_label_" + this.ui_mode).text = "";
                if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
                    this.props.stopSound([{ name: this.previousSound }]);
                    // this.props.playSound([{ name: this.baseGameSound, loop: true }]);
                }
                //this.previousSound = this.baseGameSound;
                UIManager.getRef("winCelebrationContainer").alpha = 1;
                this.props.setWinCelebrationForKeyboardListener(false);
                if (!this.buttonEnabled) {
                    let timer = TIMER.TimerManager.createTimer(500);
                    timer.on('end', () => {
                        this.props.setAllButtonEnable();

                        this.buttonEnabled = true;


                    });
                    timer.start(false);

                }
            }
        });
        timer.start(true, this.handleEventTimer);

    }
    CloseScreen_() {

        let timer = TIMER.TimerManager.createTimer(this.decreasingAlphaTimer);
        timer.on('repeat', (i: number) => {

            UIManager.getRef("winCelebrationContainer").alpha -= this.decreasingAlpha;
            if (UIManager.getRef("winCelebrationContainer").alpha < 0) {
                timer.stop();
                this.tickUpValue = 0;

                this.props.winCelebrationShow(false);
                this.props.winCelebrationStart(false, "Cash");
                if (!this.buttonEnabled) {
                    this.props.setAllButtonEnable();

                    this.buttonEnabled = true;
                }
                this.props.nextAutoplay();
                this.props.nextFreegame();
                //UIManager.getRef("text_WinCelebration_label_" + this.ui_mode).text = "";
                this.props.stopSound([{ name: this.previousSound }]);
                this.props.playSound([{ name: this.baseGameSound, loop: true }]);
                this.previousSound = this.baseGameSound;
                UIManager.getRef("winCelebrationContainer").alpha = 1;
                this.props.setWinCelebrationForKeyboardListener(false);
            }
        });
        timer.start(true, this.handleEventTimer);

    }

    render() {
        if (!this.props.showWinCelebration) {
            return (<></>)
        }
        return (
            <UIManager id={"winCelebrationContainer"} name={"winCelebrationContainer"} type={"Container"}
                ref={i => this.winCelebrationContainer = i}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            app={this.app} configGame={configGame} constant={constant}
                            id={i.id} name={i.name} {...i} tickupupdate={this.onTickupUpdate.bind(this)}
                            tickupComplete={this.onTickupComplete.bind(this)} />)
                }
            </UIManager>
        );
    }


}

export default withPixiApp(connect(
    (state: Pick<IStore, 'freegameState' | 'winCelebrationState' | 'paytableState' | 'introductionState' | 'applicationState' | 'soundState' | 'basegameState' | 'behaviourState'>): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
        startWinCelebration: state.winCelebrationState.startWinCelebration,
        showAmount: state.winCelebrationState.showAmount,
        showWinCelebration: state.winCelebrationState.showWinCelebration,
        soundIsPlaying: state.soundState.soundIsPlaying,
        betList: state.basegameState.betList,
        currentBetIndex: state.basegameState.currentBetIndex,
        winAmount: state.basegameState.winAmount,
        totalCreditWinAmount: state.behaviourState.totalCreditWinAmount,
        featureJustFinished: state.freegameState.featureJustFinished,
        inFreeGame: state.freegameState.inFreeGame,
        featureJustReTriggered: state.freegameState.featureJustReTriggered,
        freegameSpinCountRemaining: state.freegameState.freegameSpinCountRemaining,
        featureType: state.basegameState.featureType,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        winCelebrationShow: (showWinCelebration: boolean): any => dispatch(winCelebrationActions.winCelebrationShow(showWinCelebration)),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        winCelebrationStart: (startWinCelebration: boolean, showAmount: string): any => dispatch(winCelebrationActions.winCelebrationStart(startWinCelebration, showAmount)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
        stopSound: (soundName: any): any => dispatch(soundActions.stopSound(soundName)),
        nextAutoplay: (): any => dispatch(basegameAction.nextAutoplay()),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        setWinCelebrationForKeyboardListener: (winCelebrationForKeyBoardListener: boolean): any => dispatch(keyboardListenerActions.setWinCelebrationForKeyboardListener(winCelebrationForKeyBoardListener)),
        changeVolume: (soundObject: any): any => dispatch(soundActions.changeVolume(soundObject)),
        stopFreegame: (): any => dispatch(freegameAction.stopFreegame()),
        setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(basegameAction.setApplicationToBaseGameState(basegamestate)),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        showFeatureRetrigger: (): any => dispatch(retriggerActions.showFeatureRetrigger()),
        featureActive: (isFeatureActive: boolean): any => dispatch(gameRandomWildActions.featureActive(isFeatureActive)),
    }))(withWinCelebrationConfiguration(WinCelebration)));